import React from 'react'
import PageTitle, { recordLabel, useAgencyName } from 'syft-acp-core/components/PageTitle'
import AgencyAccountsList from 'syft-acp-core/entities2/AgencyAccountsList'
import { AgencySubNavigation } from './AgencySubNavigation'

import { AgenciesTrackingProvider } from './AgenciesTrackingProvider'

export const AgencyAccounts = ({ match: { params } }) => {
  const agencyIDParam = params.id ? Number(params.id) : undefined
  const agencyName = useAgencyName(agencyIDParam)

  return (
    <PageTitle title={['Accounts', recordLabel('Agency', agencyIDParam, agencyName)]}>
      <AgencySubNavigation agencyID={agencyIDParam} agencyName={agencyName} />
      <AgenciesTrackingProvider agencyId={agencyIDParam}>
        <AgencyAccountsList agencyId={agencyIDParam} />
      </AgenciesTrackingProvider>
    </PageTitle>
  )
}
